import api from '@/ts/api';
import { defineStore } from 'pinia';

// admin assets: api/admin_assets.go
export const Assets = defineStore('assets', {
  state: () => ({
    creating: false,
    progress: undefined, // human readable step while creating
  }),

  getters: {
    // default admin search query (model.AssetQuery)
    query: () => () => ({
      limit: 50,
      offset: 0,
      sort: 'id',
      desc: true,
      eq: {deleted: false},
      gt: {},
      lt: {},
      like: {},
    }),
  },

  actions: {

    // create a new asset on behalf of the logged admin account:
    //   assets/init            -> {asset, chat}   (api/api_assets_init.go: asset, chat, member, item, score)
    //   POST /upload/file?name -> {file:{id}}     (api/api_files.go)
    //   chats/message          -> {chat, text, files}
    // the user route is used on purpose: Messages.Router skips team messages,
    // and only user messages in an asset chat start the GPT detection
    // returns {id, chat} or {error}
    async create(text, files){
      if (this.creating) return {error: {id: 'busy', code: 429}}
      this.creating = true
      try {
        this.progress = 'Creating asset...'
        let init = await api.send('assets/init', {})
        if (init.error) return init
        let asset = init.resp?.asset || {}
        let chat = init.resp?.chat
        if (!asset.id || !chat) return {error: {id: 'init', code: 500}}

        let ids = []
        let list = files || []
        for (let i = 0; i < list.length; i++) {
          const file = list[i]
          this.progress = `Uploading ${i + 1}/${list.length}: ${file.name}`
          let body = await api.upload.getbytes(file)
          let up = await api.upload.file(body, file.name)
          if (up.error) return up
          let id = up.resp?.file?.id
          if (!id) return {error: {id: 'upload', code: 500, explain: file.name}}
          ids.push(id)
        }

        if (!text && !ids.length) return {id: asset.id, chat}

        this.progress = 'Sending to the asset chat...'
        let res = await api.send('chats/message', {chat, text: text || undefined, files: ids.length ? ids : undefined})
        if (res.error) return res
        return {id: asset.id, chat}
      } finally {
        this.creating = false
        this.progress = undefined
      }
    },

    // v-upload.images handler: create an asset from dropped images and open it
    async guess(files){
      if (!files || !files.length) return
      let res = await this.create(undefined, Array.from(files))
      if (res.error) {
        console.error('assets/guess', res.error)
        return
      }
      window.location = `/assets/${res.id}`
    },

    // q = model.AssetQuery, returns []model.Asset
    async search(q){
      let res = await api.assets.search(q)
      if (res.error) {
        console.error(res.error)
        return []
      }
      return res.resp || []
    },

    // assets of a category
    async list(root, limit, offset){
      let q = this.query()
      q.limit = limit || 50
      q.offset = offset || 0
      if (root) q.eq.root = root
      return await this.search(q)
    },

    async get(id){
      return await api.assets.get(id)
    },

    async update(id, k, v){
      return await api.assets.update(id, k, v)
    },

    async updateMeta(id, k, v){
      return await api.assets.updateMeta(id, k, v)
    },

    async delete(id){
      return await api.assets.delete(id)
    },

    async verify(id){
      return await api.assets.verify(id)
    },

  },

})
